import { cacheDeleteMessageSchedule } from '../utils/schedule-message-handlers';
import { useApolloClient, useSubscription } from '@apollo/client';
import { SUBSCRIPTION_MESSAGE_SCHEDULE } from '@/graphql/subscription.graphql';

export function useScheduledMessageSubscription() {
  const client = useApolloClient();
  useSubscription(SUBSCRIPTION_MESSAGE_SCHEDULE, {
    onData: (response) => {
      const data = response?.data;
      const id = data?.data?.messageSchedule?.id;
      if (!id) return;
      cacheDeleteMessageSchedule(id);
      client.refetchQueries({ include: ['GetMessageScheduleCount'] });
    },
  });
}
